
import sulu from 'razlet-sulu-sdk/lib/mixins/sulu';

export default {
  name: 'news-page',
  mixins: [sulu],
};
